import { render, staticRenderFns } from "./AccountPay.vue?vue&type=template&id=4ed774c4&scoped=true"
import script from "./AccountPay.vue?vue&type=script&lang=js"
export * from "./AccountPay.vue?vue&type=script&lang=js"
import style0 from "./AccountPay.vue?vue&type=style&index=0&id=4ed774c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed774c4",
  null
  
)

export default component.exports